var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 32,
    viewBox: "0 0 84 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 31,
    rx: 6,
    fill: "#EE4D2D"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 22,
    textAnchor: "middle",
    fontFamily: "Lexend, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 700,
    fill: "#FFFFFF",
    letterSpacing: 1.5
  }, "SPX")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpxLogo);
export default __webpack_public_path__ + "static/media/SpxLogo.5cca8aba92f0dce24d47c8c959b64e1e.svg";
export { ForwardRef as ReactComponent };